import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="hero-section relative min-h-screen flex items-center justify-center" id="home">
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1554941829-202a0b2403b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHN0dWRpb3xlbnwwfHx8fDE3NzA0MTEyODV8MA&ixlib=rb-4.1.0&q=85)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      />
      
      {/* Arka Planı Karartan Katman */}
      <div className="absolute inset-0 z-10 bg-black/60 shadow-inner" />

      {/* İçerik */}
      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20">
        <div className="animate-fadeInUp">
          {/* Rozet */}
          <div className="inline-flex items-center gap-2 bg-black/40 backdrop-blur-md border border-brand-hot-pink/40 rounded-full px-4 py-2 mb-6 text-white shadow-lg">
            <Sparkles className="text-brand-glow" size={20} />
            <span className="text-sm font-bold tracking-wide">Premium Video Editing Agency</span>
          </div>

          {/* Başlık */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black mb-6 leading-tight drop-shadow-2xl">
            <span className="block text-white">We Turn Your</span>
            <span className="block text-glow" style={{ color: '#F76AC3', textShadow: '0 0 20px rgba(247, 106, 195, 0.5)' }}>
              Raw Footage
            </span>
            <span className="block text-white">Into Viral Assets</span>
          </h1>

          {/* Alt Başlık */}
          <p className="text-lg sm:text-xl md:text-2xl text-white max-w-3xl mx-auto mb-10 leading-relaxed drop-shadow-md">
            ViralVantage Media helps you <span className="text-brand-magenta font-bold">dominate social media</span> and 
            save <span className="text-brand-glow font-bold">20+ hours a week</span> with high-retention video editing
          </p>

          {/* Butonlar */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <button
              onClick={() => {
                const element = document.getElementById('free-audit');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-brand-magenta hover:bg-brand-magenta/90 text-white px-8 py-4 rounded-full font-bold text-lg flex items-center gap-2 group transition-all transform hover:scale-105 shadow-lg shadow-brand-magenta/20"
            >
              Get Free Video Audit
              <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
            </button>
            <button
              onClick={() => {
                const element = document.getElementById('portfolio');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-black transition-all duration-300 transform hover:scale-105"
            >
              View Our Work
            </button>
          </div>

          {/* İstatistikler - Hatasız ve Okunaklı Hali */}
          <div className="inline-flex flex-wrap justify-center items-center gap-x-10 gap-y-4 px-8 py-4 bg-black/50 backdrop-blur-lg rounded-2xl border border-white/10 shadow-2xl">
            <div className="flex items-center gap-3">
              <div className="w-3 h-3 bg-brand-magenta rounded-full shadow-[0_0_10px_#F76AC3]" />
              <span className="text-white font-bold text-sm sm:text-base">500M+ Views Generated</span>
            </div>
            
            <div className="flex items-center gap-3 sm:border-l sm:border-white/20 sm:pl-10">
              <div className="w-3 h-3 bg-brand-glow rounded-full shadow-[0_0_10px_#00F2FF]" />
              <span className="text-white font-bold text-sm sm:text-base">2000+ Videos Delivered</span>
            </div>
            
            <div className="flex items-center gap-3 sm:border-l sm:border-white/20 sm:pl-10">
              <div className="w-3 h-3 bg-white rounded-full shadow-[0_0_10px_#FFFFFF]" />
              <span className="text-white font-bold text-sm sm:text-base">95% Avg. Retention Rate</span>
            </div>
          </div>
        </div>
      </div>

      {/* Kaydır Göstergesi */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 animate-bounce">
        <div className="w-6 h-10 border-2 border-brand-hot-pink rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-brand-hot-pink rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;